import { createWorkerAction } from '../lib';

export const openMobileOverlay = createWorkerAction('OPEN_MOBILE_OVERLAY');

export const openFullScreenOverlay = createWorkerAction(
  'OPEN_FULL_SCREEN_OVERLAY',
);
